import { render, staticRenderFns } from "./OnsiteSearchNoResult.vue?vue&type=template&id=4c06ea46&"
import script from "./OnsiteSearchNoResult.vue?vue&type=script&lang=ts&"
export * from "./OnsiteSearchNoResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports